import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import RevenueGoal from "../components/revenueGoal/RevenueGoal";
import * as RevenuaGoalAction from "../actions/RevenuaGoalAction";
import * as AdminHomeAction from "../actions/AdminHomeAction";

function mapStateToProps(state) {
    return {
        agencyLocation: state.AgencyLocationReducer,
        plList: state.PlListReducer,
        defaultAgencyProfile: state.DefaultAgencyProfileReducer
    };
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(Object.assign({}, RevenuaGoalAction, AdminHomeAction), dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(RevenueGoal);



// WEBPACK FOOTER //
// ./src/containers/RevenueGoalContainer.js